import type { MessageSettings } from '@shared/services/systemSettings/types/getMessageSettings.types';

export const getMessageSettingByCode = (code: string, messageData: MessageSettings[] | null) =>
  messageData?.find((obj) => obj.Code === code);
